import {
  FETCH_PATIENTPAYMENTDETAILS_SUCCESS_ACTION,
} from "./action";

const initialState = {
  processing: false,
  error: false
};

export default function(state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_PATIENTPAYMENTDETAILS_SUCCESS_ACTION:
      return {
        ...state,
        patientPaymentDtlsList: action.payload.rows,
        patientPaymentDtlsCount: action.payload.count
      };

    default:
      return {
        ...state
      };
  }
}
